import { QueryKey } from "@tanstack/react-query";
import { GetBookingParams } from "./booking.types";

export const BOOKING_KEYS = {
  BOOKINGS: "bookings",
  BOOKING: "booking",
  GET_BOOKINGS: (params?: GetBookingParams): QueryKey => [
    BOOKING_KEYS.BOOKINGS,
    params,
  ],
  GET_BOOKING: (id: string): QueryKey => [BOOKING_KEYS.BOOKING, id],
  GET_UPCOMING_BOOKINGS: (params?: GetBookingParams): QueryKey => [
    BOOKING_KEYS.BOOKINGS,
    "upcoming",
    params,
  ],
  GET_PAST_BOOKINGS: (params?: GetBookingParams): QueryKey => [
    BOOKING_KEYS.BOOKINGS,
    "past",
    params,
  ],
  GET_MY_BOOKINGS: (params?: GetBookingParams): QueryKey => [
    BOOKING_KEYS.BOOKINGS,
    "my-bookings",
    params,
  ],
  GET_MY_SERVICE_CLIENT_BOOKINGS: (params?: GetBookingParams): QueryKey => [
    BOOKING_KEYS.BOOKINGS,
    "my-service-client-bookings",
    params,
  ],
  GET_ALL_MY_RELATED_BOOKINGS: (params?: GetBookingParams): QueryKey => [
    BOOKING_KEYS.BOOKINGS,
    "all-my-related-bookings",
    params,
  ],
  GET_UPCOMING_BOOKINGS_INCLUDING_SERVICES: (params?: GetBookingParams): QueryKey => [
    BOOKING_KEYS.BOOKINGS,
    "upcoming-with-services",
    params,
  ],
  GET_PAST_BOOKINGS_INCLUDING_SERVICES: (params?: GetBookingParams): QueryKey => [
    BOOKING_KEYS.BOOKINGS,
    "past-with-services",
    params,
  ],
  GET_JOB_TICKETS_BY_SERVICE_TICKETS: (params?: GetBookingParams): QueryKey => [
    BOOKING_KEYS.BOOKINGS,
    "service-tickets",
    params,
  ],
};
